import { router } from 'src/router'
import { LOCAL_STORAGE_KEYS } from 'src/tpbp-core/models/common.const'

export function getMockScenario(): string {
  if (process.env.VUE_APP_ENABLE_MOCK_SCENARIOS !== 'true') return ''

  const userRole = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_ROLE)
  const userEmail = localStorage.getItem(LOCAL_STORAGE_KEYS.USER_NAME)

  return userRole && userEmail ? `${userRole}-${userEmail}` : ''
}

export function getMockPagePath(): string {
  if (process.env.VUE_APP_ENABLE_MOCK_PAGE_PATH !== 'true') return ''

  return router.currentRoute.path
}
